import { createSlice } from '@reduxjs/toolkit';
import { createDevUser } from '../helpers/devHelpers';
import isAuthEnabled from '../helpers/authHelpers';

export const getInitialState = () => {
  return (isAuthEnabled()) ? {} : createDevUser();
}

export default createSlice({
  name: 'user',
  initialState: getInitialState(),
  reducers: {
    logged: (state, event) => {
      return { ...state, ...event.payload };
    },
    logout: () => {
      return {};
    },
  },
});
